import { createApp } from "vue";
import muscles from './components/muscles.vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import DialogService from 'primevue/dialogservice';
import PrimeVueDcf from './includes/primeVueDcf.js';
import fetchData from './includes/fetchData.js';
import errorHandler from './includes/errorHandler.js';

// import '../css/style.css';

const app = createApp(muscles);

app.mixin(fetchData);
app.mixin(errorHandler);

app.use(PrimeVue, PrimeVueDcf);
app.use(ToastService);
app.use(DialogService);

app.mount('#muscles');
